import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/Common/BackButton';

const GrowUp: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-whiteGrayBackground flex flex-col justify-center items-center font-sofiaSans">
      <div className="w-full max-w-sm px-8 flex flex-col items-center">
        <div className="text-left mb-8 mt-2">
          <h1
            className="text-3xl sm:text-4xl font-extrabold text-black leading-tight mb-4"
            style={{ letterSpacing: '-0.02em' }}
          >
            Let's Get a Grown-
            <br className="sm:hidden" />
            Up
          </h1>
          <p className="text-base text-black leading-relaxed max-w-xs mx-auto">
            To use Build My Story at home, a parent or guardian needs to help set things up. This keeps your account
            safe and lets you keep working on your story.
          </p>
        </div>
        <button
          className="w-full max-w-xs py-2 px-4 mb-6 rounded-lg bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold text-base shadow-md hover:shadow-lg transition-shadow focus:outline-none focus:ring-2 focus:ring-secondaryStoryAdditionalLightBlueText focus:ring-offset-2"
          onClick={() => navigate('/auth/student/parent')}
        >
          Continue as a parent
        </button>
        <div className="flex items-center justify-between w-full max-w-xs">
          <div>
            <BackButton onClick={() => window.history.back()}></BackButton>
          </div>
          <img src="/new_black_logo.png" alt="Build My Story" className="h-6" />
        </div>
      </div>
    </div>
  );
};

export default GrowUp;
